export class AdFoxServiceManager {
  private ads: Map<string, any>;
  private watchers: Map<string, Array<IAdFoxWatcher>>;
  private middlewares: Map<string, IAdFoxMiddleware[]>;

  public constructor() {
    this.ads = new Map();
    this.watchers = new Map();
    this.middlewares = new Map();
  }

  public registerMiddleware(type: string, middleware: IAdFoxMiddleware): void {
    if (!this.middlewares.has(type)) {
      this.middlewares.set(type, []);
    }

    this.middlewares.set(
      type,
      this.middlewares.get(type).concat([middleware])
    );
  }

  public waitForAd(type: string, watcher: IAdFoxWatcher): void {
    if (this.ads.has(type)) {
      watcher(this.ads.get(type));
      return;
    }

    this.watchers.set(
      type,
      (this.watchers.get(type) || []).concat([watcher])
    );
  }

  public registerAd(type: string, meta: any): void {
    const middlewares = this.middlewares.get(type) || [];

    middlewares
      .reduce((promiseWithMeta, middleware) => {
        return promiseWithMeta
          .then(meta => middleware(meta));
      }, Promise.resolve(meta))
      .then(meta => {
        if (this.watchers.has(type)) {
          this.watchers.get(type)
            .forEach(watcher => watcher(meta));

          this.watchers.set(type, []);
        }

        this.ads.set(type, meta);
      });
  }
}



// WEBPACK FOOTER //
// ./src/bundles/adfox/adfox_service_manager.ts